import styled from 'styled-components';
import { DialogContent } from '@material-ui/core';

export const Header = styled.header`
  position: relative;
  width: 100%;
  font-size: 1.5rem;
  font-weight: 500;
  margin: 0 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  button {
    margin-right: .25rem;
  }

  @media screen and (min-width: 600px) {
    font-size: 2rem;
  }
`;
export const Main = styled.main`
  position: relative;
  width: 100%;
  margin: 0 auto;
`;

export const Content = styled(DialogContent)`
  &.MuiDialogContent-root {
    margin: auto;
    margin-top: ${({ margintop = 0 }) => margintop};

    @media(min-width: 600px) {
      max-width: 540px;
      min-height: 500px;
    }
  }
`;
